/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for User controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetCurrentUserResponse, UpdateProfileRequest, GetPermissionsResponse, UpdatePermissionsRequest, GetUsersResponse, CreateUserRequest, CreateUserResponse } from "../models";

@Injectable({ providedIn: "root" })
export class UserService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    uploadAvatar(avatar: Blob, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    uploadAvatar(avatar: Blob, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    uploadAvatar(avatar: Blob, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    uploadAvatar(avatar: Blob, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/User/me/Avatar`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (avatar !== undefined) {
            formData.append('avatar', avatar);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, formData, requestOptions);
    }

    getCurrentUser(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCurrentUserResponse>;
    getCurrentUser(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCurrentUserResponse>>;
    getCurrentUser(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCurrentUserResponse>>;
    getCurrentUser(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/User/me`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateProfile(updateProfileRequest: UpdateProfileRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateProfile(updateProfileRequest: UpdateProfileRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateProfile(updateProfileRequest: UpdateProfileRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateProfile(updateProfileRequest: UpdateProfileRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/User/me`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateProfileRequest, requestOptions);
    }

    getPermissions(userAccountId: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetPermissionsResponse>;
    getPermissions(userAccountId: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetPermissionsResponse>>;
    getPermissions(userAccountId: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetPermissionsResponse>>;
    getPermissions(userAccountId: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/User/${userAccountId}/permissions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updatePermissions(userAccountId: string, updatePermissionsRequest: UpdatePermissionsRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updatePermissions(userAccountId: string, updatePermissionsRequest: UpdatePermissionsRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updatePermissions(userAccountId: string, updatePermissionsRequest: UpdatePermissionsRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    /** Replaces all permissions for the given user */
    updatePermissions(userAccountId: string, updatePermissionsRequest: UpdatePermissionsRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/User/${userAccountId}/permissions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updatePermissionsRequest, requestOptions);
    }

    getUsers(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetUsersResponse>;
    getUsers(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetUsersResponse>>;
    getUsers(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetUsersResponse>>;
    getUsers(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/User`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createUser(createUserRequest: CreateUserRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateUserResponse>;
    createUser(createUserRequest: CreateUserRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateUserResponse>>;
    createUser(createUserRequest: CreateUserRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateUserResponse>>;
    createUser(createUserRequest: CreateUserRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/User`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createUserRequest, requestOptions);
    }

    getUserAvatar(id: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Blob>;
    getUserAvatar(id: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Blob>>;
    getUserAvatar(id: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Blob>>;
    getUserAvatar(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/User/${id}/Avatar`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            responseType: 'blob' as 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    deleteUser(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteUser(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteUser(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteUser(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/User/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }
}
